import { SpotifyIcon } from '@fingertip/icons'

export const SpotifyIconBox = () => {
  return (
    <div className="absolute -left-1 -top-1 size-fluid-8 rounded-full bg-white text-[#1DB954]">
      <SpotifyIcon className="size-fluid-8" />
    </div>
  )
}
